<template>
  <div :class="classList">
    <div class="reveal-wrap" data-aos="reveal" data-aos-duration="1200">
      <div class="reveal-block"></div>
      <img :src="require('../../assets/images/' + imageSrc)" />
    </div>
    <div class="reveal-wrap reveal-shadow"  data-aos="reveal" data-aos-duration="1200">
      <div class="reveal-block"></div>
      <div class="shadow-block"></div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'RevealBlock',
  props: ['classList', 'imageSrc']
}
</script>
<style lang="scss" scoped>
  .reveal-margin{
    position: relative;
    width: 100%;
    margin-top: 180px;
    margin-bottom: 100px;
    overflow-x: hidden;
    @media screen and (max-width: 1100px) {
      margin-top: 80px;
      margin-bottom: 50px;
    }
    &.reveal-top{
      top: 180px;
      margin-top: 0;
      @media screen and (max-width: 1100px) {
        margin-top: 0;
        top: 80px;
      }
    }
    &.reveal-home{
      margin: 50px 0 -80px;
      @media screen and (max-width: 1100px) {
        margin-top: 50px;
        margin-bottom: -50px;
      }
    }
    &.reveal-center{
      .reveal-wrap{
        justify-content: center;
        flex-wrap: wrap;
        padding: 0 25%;
        @media screen and (max-width: 1100px) {
          padding: 0 15%;
        }
        @media screen and (max-width: 900px) {
          padding: 0 20px;
        }
        img{
          height: auto;
          width: 100%;
          align-self: flex-start;
          @media screen and (max-width: 900px) {
            
            right: 0;
            left: 0;
          }
        }
        .shadow-block{
          left: 25%;
          .reveal-block{
            left: 25%;
          }
          @media screen and (max-width: 1100px) {
            left: 15%;
            .reveal-block{
              left: 15%;
            }
          }
          @media screen and (max-width: 900px) {
            left: 0;
            right: 20px;
            .reveal-block{
              left: 0;
            }
          }
        }
      }
    }
  }
  .reveal-wrap {
    position: relative;
    right: 0;
    padding: 0 0;
    height: 380px;
    width: auto;
    display: flex;
    justify-content: flex-end;
    overflow: hidden;
    opacity: 0;
    transition-property: opacity;
    z-index: 2;
    @media screen and (max-width: 1100px) {
      height: 250px;
    }
    @media screen and (max-width: 900px) {
      height: 190px;
    }
    &.reveal-shadow{
      margin-top: -280px;
      z-index: 1;
      transition-delay: .5s;
      @media screen and (max-width: 1100px) {
        margin-top: -150px;
      }
      @media screen and (max-width: 900px) {
        margin-top: -80px;
      }
      .reveal-block {
        left: 15%;
        &::before {
          transition-delay: .75s;
          left: 0;
          z-index: 2;
        }
        @media screen and (max-width: 900px) {
          left: 20px;
        }
      }
    }
    img{
      display: block;
      height: 100%;
      width: auto;
      opacity: 1 !important;
      filter: none !important;
      @media screen and (max-width: 900px) {
        
        right: 20px;
      }
    }
    .shadow-block{
      position: absolute;
      height: 100%;
      left: 15%;
      right: 0;
      overflow: hidden;
      background-color: #F5F5F5;
    }
    .reveal-block {
      position: absolute;
      top: 0;
      width: 100%;
      height: 101%;
      left: 0;
      &::before {
        position: absolute;
        content: '';
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: white;
        transition-property: transform;
        transition-duration: 1s;
        transition-timing-function: cubic-bezier(0.215, 0.610, 0.355, 1);
        transform: scaleX(1);
        transform-origin: 0% 100%;
        transition-property: transform;
        transition-delay: 0.5s;
      }
    }
   
    &[data-aos='reveal']{
      &.aos-animate{
        opacity: 1;
        .reveal-block {
          &::before {
            transform: scaleX(0);
            transform-origin: 100% 0%;
          }
        }
      }
    }
    
  }
</style>


// WEBPACK FOOTER //
// RevealBlock.vue?fdef6a52